import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

Vue.http.options.root = process.env.API

Vue.http.interceptors.push((request, next) => {
  request.headers.set('Authorization', `Bearer ${window.localStorage.getItem('default-auth-token')}`)
  request.headers.set('Accept', 'application/json')
  next()
})

export default Vue



// WEBPACK FOOTER //
// ./src/services/index.js